/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';

/**
 * 
 * @export
 * @interface GetProduct200ResponseAllOfData
 */
export interface GetProduct200ResponseAllOfData {
    /**
     * 
     * @type {Product}
     * @memberof GetProduct200ResponseAllOfData
     */
    product: Product;
}

/**
 * Check if a given object implements the GetProduct200ResponseAllOfData interface.
 */
export function instanceOfGetProduct200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "product" in value;

    return isInstance;
}

export function GetProduct200ResponseAllOfDataFromJSON(json: any): GetProduct200ResponseAllOfData {
    return GetProduct200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetProduct200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProduct200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product': ProductFromJSON(json['product']),
    };
}

export function GetProduct200ResponseAllOfDataToJSON(value?: GetProduct200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product': ProductToJSON(value.product),
    };
}

